import { render, staticRenderFns } from "./AssignmentRuleSection.vue?vue&type=template&id=0b91b9c6&scoped=true&"
import script from "./AssignmentRuleSection.vue?vue&type=script&lang=js&"
export * from "./AssignmentRuleSection.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentRuleSection.vue?vue&type=style&index=0&id=0b91b9c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b91b9c6",
  null
  
)

export default component.exports